import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { CREATE_REFERRAL_QUERY_KEY } from '../constants';
import { CreateReferralResponse, CreateReferralValues } from '../views/CreatePatientReferralScreen/CreatePatientReferralScreen.types';
import { createReferral } from '../services';

function useMutationCreateReferral(
  onSuccess: (data: CreateReferralResponse) => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const mutationFn = async (props: CreateReferralValues): Promise<any> => {
    return await createReferral(props);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (
    data: any,
    _variables: CreateReferralValues,
    _context: CreateReferralValues,
  ): Promise<void> => {
    onSuccess?.(data);
  };

  return useMutation<string, unknown, any, any>([CREATE_REFERRAL_QUERY_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationCreateReferral;
